<template>
    <div>
        <h2
            v-if="tableHeading"
            :id="uniqueId"
            class="h5"
        >
            {{ tableHeading }}
        </h2>
        <div
            v-if="tableHasContent"
            class="table-container"
        >
            <table
                :aria-labelledby="tableHeading ? uniqueId : null"
                class="monitori-table"
            >
                <thead>
                    <tr>
                        <th
                            v-for="(header, index) in tableData.header"
                            :key="index"
                            scope="row"
                        >
                            <span>{{ header }}</span>
                        </th>
                    </tr>
                </thead>
                <tbody class="table-data">
                    <tr
                        v-for="(dataset, index) in tableData.data"
                        :key="index"
                        class="table-data-row"
                    >
                        <!-- eslint-disable vue/no-v-html -->
                        <td
                            v-for="(value, indexDs) in dataset"
                            :key="indexDs"
                            class="table-data-col"
                            v-html="value"
                        />
                        <!--eslint-enable-->
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-facing-decorator"
    import TableData from "@/models/tabledata"

    @Component
    export default class DynamicTable extends Vue {
        uniqueId: string = ""

        @Prop() tableHeading: string | undefined
        @Prop({ type: TableData }) tableData: TableData | undefined

        get tableHasContent(): boolean {
            return this.tableData?.data?.length > 0
        }

        created() {
            this.uniqueId = "id-" + Math.random().toString(16).slice(2)
        }
    }
</script>

<style scoped>
    .table-container {
        overflow-y: auto;
        /*height: 400px;*/ /*' TODO: minkä korkuinen taulukko? */
        /*height: calc(100vh - 140px - var(--var-footer-height) - var(--var-header-height));  TODO: tarkistaa onko se ok? */
    }

    /** otsikko ja footer pysymään paikallaan kun scrollataan */
    table thead,
    table tfoot {
        position: sticky;
        z-index: 1;
    }

    table thead {
        inset-block-start: 0; /* "top" */
    }

    table tfoot {
        inset-block-end: 0; /* "bottom" */
    }

    .monitori-table {
        table-layout: fixed;
        width: 100%;
    }

    .monitori-table tbody {
        display: table-row-group;
        width: 100%;
        overflow: auto;
        height: 100%;
    }

    .monitori-table thead tr {
        width: 100%;
        background-color: var(--Traficom-main-color);
        color: white;
    }

    tbody tr:nth-child(even) {
        background-color: #F2F4F8;
    }

    thead th, tbody td {
        padding: 5px 10px;
        word-break: break-word;
    }
</style>
